import useNewCareerPositionContext from 'contexts/career-position.context';
import React from 'react';

const PreviewJobDetails = () => {
  const { createJobPositionForm } = useNewCareerPositionContext();

  const details = [
    { value: createJobPositionForm.jobTitle, label: 'Job Title' },
    { value: createJobPositionForm.department, label: 'Department/Team' },
    { value: createJobPositionForm.workMode, label: 'Work Mode' },
    { value: createJobPositionForm.experience, label: 'Experience level' },
    { value: createJobPositionForm.location, label: 'Location' }
  ];
  return (
    <div className='space-y-6'>
      {details.map((detail) => (
        <div
          key={detail.label}
          className='border border-gray-1 rounded-md p-3.5 flex items-center mb-4'>
          <h2 className='text-sm   text-gray-5 w-40'>{detail.label}</h2>
          <p className='text-base text-gray-6 font-medium'>{detail.value}</p>
        </div>
      ))}
    </div>
  );
};

export default PreviewJobDetails;
